import React from "react";
import ReactDOM from "react-dom/client";
import App from "@/App.tsx";
import { initSentry, WebSocket } from "@/config";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/notifications/styles.css";
import "@/assets/scss/main.scss";
import { BrowserRouter } from "react-router-dom";
import "@/i18n";

// Init Sentry
initSentry();

// Init WebSocket
WebSocket.init({ autoConnect: true });

ReactDOM.createRoot(document.getElementById("root")!).render(
	<React.StrictMode>
		<BrowserRouter>
			<App />
		</BrowserRouter>
	</React.StrictMode>
);
